export function mapSizeToStyles(size, theme) {
    if (!size) {
        return getStylesForSize('medium', theme);
    }
    if (typeof size === 'string') {
        return getStylesForSize(size, theme);
    }
    return Object.entries(size).reduce((acc, [breakpoint, sizeValue]) => {
        const castedBreakpoint = breakpoint;
        if (castedBreakpoint === 'xs') {
            return { ...acc, ...getStylesForSize(sizeValue, theme) };
        }
        acc[theme.breakpoint.minWidth(castedBreakpoint)] = getStylesForSize(sizeValue, theme);
        return acc;
    }, {});
}
function getStylesForSize(size, theme) {
    if (size === 'small') {
        return {
            fontSize: theme.typography.h5.fontSize,
            lineHeight: theme.typography.h5.lineHeight,
        };
    }
    return {
        fontSize: theme.typography.h3.fontSize,
        lineHeight: theme.typography.h3.lineHeight,
    };
}
//# sourceMappingURL=utils.js.map